<template>
  <!-- 角色管理 -->
  <div class="wrapper">
    <el-button
        style="margin-bottom:20px;"
        v-checkbtn="isShowBtn(AUTH_BTN.role_list_add)"
        type="primary"
        size="small"
        @click="showAddOrEdit = true;rowId = null"
    >新增</el-button
    >

    <tp-table
        :isNeedSerialNumber="true"
        :tableData="roleList"
        :columns="columns"
        :totalNum="total"
        :current-page.sync="currentPage"
        :pageSize.sync="pageSize"
    />

    <!-- 授权 -->
    <el-drawer ref="drawer" title="角色权限" :visible.sync="drawer" :show-close="false">
      <el-card>
        <div slot="header">
          <el-button type="primary" size="small" @click="saveAuthority">保存设置</el-button>
        </div>
        <div>
          <el-tree
              ref="tree"
              highlight-current
              :data="menuTree"
              show-checkbox
              node-key="id"
              default-expand-all
              :default-checked-keys="grantMenuObj.menuIdList"
              :props="defaultProps"
              @check="checkChange"
          >
          </el-tree>
        </div>
      </el-card>
    </el-drawer>

    <!-- 新增&编辑 -->
    <AddOrEdit
        v-if="showAddOrEdit"
        :rowId="rowId"
        :showAddOrEdit="showAddOrEdit"
        @closeDialog="closeDialogFun"
    />
  </div>
</template>

<script>
import { getRoleList, removeRole, getMenusTree, grantMenu, getRoleDetail } from './api';
import { authBtnMixin } from '@/mixins/authBtnMixin';
import AddOrEdit from "./add-edit.vue";

const columns = [
  {
    label: '角色',
    prop: 'roleName',
    customRender(h, row) {
      return (
          <p class="one-line" title={row['roleName']}>
            {row['roleName']}
          </p>
      )
    }
  },
  {
    label: '描述',
    prop: 'remark',
    customRender(h, row) {
      return (
          <p class="one-line" title={row['remark']}>
            {row['remark']}
          </p>
      )
    }
  },
  {
    label: '创建时间',
    prop: 'createTime',
    customRender(h, row) {
      return (
          <p class="one-line" title={row['createTime']}>
            {row['createTime']}
          </p>
      )
    }
  },
  {
    label: '操作',
    width: '180',
    customRender(h, row) {
      return (
          <div>
            <el-link
                v-show={this.isShowBtn(this.AUTH_BTN.role_list_edit)}
                underline={false}
                type="primary"
                onClick={() =>{
                  this.showAddOrEdit = true;
                  this.rowId = row["id"];
                }}
            >
              编辑
            </el-link>

            <el-link
                v-show={this.isShowBtn(this.AUTH_BTN.role_list_grant)}
                underline={false}
                style="margin:0 10px"
                type="primary"
                onClick={() => this.showMenu(row['id'])}
            >
              授权
            </el-link>

            <el-link
                v-show={this.isShowBtn(this.AUTH_BTN.role_list_del)}
                underline={false}
                type="danger"
                onClick={() => this.delRole(row['id'])}
            >
              删除
            </el-link>
          </div>
      )
    }
  }
];

export default {
  name: 'SystemRoleAddOrEdit',
  mixins: [authBtnMixin],
  components: { AddOrEdit },
  data() {
    return {
      menuModule: 'admin',
      drawer: false,
      roleList: [],
      columns,
      total: 0,
      currentPage: 1,
      pageSize: 20,
      defaultProps: {
        children: 'children',
        label: 'menuName',
        value: 'id'
      },
      menuTree: [],
      // 授权信息
      grantMenuObj: {
        id: null,
        menuIdList: []
      },
      searchData: {
        roleName: ''
      },
      allKeys: [],
      rowId: null,
      showAddOrEdit: false,
    }
  },
  provide() {
    return {
      context: this
    }
  },
  watch: {
    currentPage() {
      this.getRoleList();
    }
  },
  mounted() {
    this.getRoleList();
    this.apiQueryMenuTree();
  },

  methods: {
    async getRoleList() {
      let params = { roleName: this.searchData.roleName, page: this.currentPage, pageSize: this.pageSize };
      let res = await getRoleList(params);
      this.roleList = res?.list || [];
      this.total = res?.total || 0;
    },

    async apiQueryMenuTree() {
      this.menuTree = await getMenusTree();
    },
    // 复选框被点击时的回调
    checkChange() {
      // 获取当前被选中的菜单id数组
      this.grantMenuObj.menuIdList = this.$refs.tree.getCheckedKeys();
      this.allKeys = this.$refs.tree.getCheckedNodes(false, true).map(item => item.id);
    },
    // 保存菜单授权
    async saveAuthority() {
      let data = { id: this.grantMenuObj.id, menuIdList: this.allKeys };
      await grantMenu(data).then(() => {
        this.$message.success('授权成功');
        this.drawer = false;
        this.getRoleList();
      })
    },
    async delRole(id) {
      this.$confirm('确定要删除该角色吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
          .then(() => {
            removeRole({ id }).then(() => {
              this.$message.success('删除成功');
              this.getRoleList();
            })
          })
          .catch(() => {})
    },
    async showMenu(id) {
      this.grantMenuObj.menuIdList = [];
      this.apiQueryMenuTree();
      this.drawer = true;
      this.grantMenuObj.id = id;
      const { menuList } = await getRoleDetail({ id });
      this.$nextTick(() => {
        this.grantMenuObj.menuIdList = this.fileterMenuIds(menuList).filter(item => !this.$refs.tree.getNode(item).childNodes.length);
      })
    },
    fileterMenuIds(list) {
      let menuIds = [];
      list.forEach(item => {
        if (item.children && item.children.length > 0) {
          menuIds = this.fileterMenuIds(item.children);
        } else {
          menuIds.push(item.id);
        }
      })
      return menuIds;
    },
    handleClick() {
      this.getRoleList()
    },
    reset() {
      Object.assign(this._data.searchData, this.$options.data().searchData)
      this.getRoleList()
    },
    // 关闭弹框
    closeDialogFun(flag) {
      this.showAddOrEdit = false;
      if (flag) {
        this.getRoleList();
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  width: 100%;
  min-width: 800px;
  .search-header /deep/ {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    .arrow {
      text-align: right;
      .open {
        color: #409eff;
        font-size: 16px;
        margin: 0 10px;
        cursor: pointer;
      }
      .updown {
        color: #409eff;
        font-size: 16px;
        transition: all 0.5s;
      }
      .go {
        transform: rotate(-180deg);
      }
    }
    .el-form-item {
      width: 20%;
      min-width: 300px;
      margin-bottom: 0;
      margin-right: 0;
    }
  }
  .el-divider {
    margin: 20px 0;
  }
  .btn-group {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
  }
}
</style>
